import api from './api'

/**
 * Servicio encargado de la autenticación con la API-CORE (FastAPI)
 */
export const authService = {
  
  /**
   * Realiza la petición de login al endpoint /auth/login
   * @param {string} username 
   * @param {string} password 
   * @returns {Promise<object>} Datos del usuario y token
   */
  login: async (username, password) => {
    try {
      const { data } = await api.post('/auth/login', { email: username, password })
      return data
    } catch (error) {
      // Re-lanzamos el error para que sea manejado por el componente UI
      throw error
    }
  },

  /**
   * Limpia la sesión en backend y almacenamiento local
   */
  logout: () => {
    api.post('/auth/logout').catch(() => {})
    localStorage.removeItem('cen_user')
  },

  /**
   * Superuser-only: scope the session to a Company's partner view.
   * @param {number} companyId
   */
  impersonate: async (companyId) => {
    const { data } = await api.post(`/companies/${companyId}/impersonate`)
    return data
  },

  /**
   * Ends the current impersonation session, if any.
   */
  endImpersonation: async () => {
    const { data } = await api.post('/companies/impersonate/end')
    return data
  },
}

export default authService
